export class Pays {
  public id: number;
  public codePays?: string;
  public description?: string;
}
